module.exports = __webpack_public_path__ + "img/add.a5aa616e.svg";